export const state = () => ({
  message: '',
  hostname: 'com',
  hideFooter: false,
  tests: [],
  features: {},
  livestream: {},
  toasts: [],
  announcer: '',
  announcerLive: 'polite'
})

const draf = cb => requestAnimationFrame(() => requestAnimationFrame(cb))

export const actions = {
  setAppMessage({ commit }, payload) {
    commit('setAppMessage', payload)
  },

  clearAppMessage({ commit }) {
    commit('clearAppMessage')
  },

  setTest({ commit }, payload) {
    commit('setTest', payload)
  },

  pushToast({ commit }, payload) {
    commit('pushToast', payload)
  },

  popToast({ commit }, id) {
    commit('popToast', id)
  },

  hideFooter({ commit }, payload = true) {
    commit('setFooter', !!payload)
  },

  announce({ commit }, payload) {
    commit('resetAnnounce')
    draf(() => commit('setAnnounce', payload))
  }
}

export const mutations = {
  setAppMessage(state, error) {
    state.message = error
  },

  clearAppMessage(state) {
    state.message = ''
  },

  setTest(state, payload) {
    state.tests.push(payload)
  },

  setFeatures(state, payload) {
    state.features = JSON.parse(payload)
  },

  setHostname(state, payload) {
    state.hostname = payload
  },

  setFooter(state, payload) {
    state.hideFooter = payload
  },

  setLivestream(state, payload) {
    state.livestream = payload
  },

  resetAnnounce(state) {
    state.announcer = ''
    state.announcerLive = 'polite'
  },

  setAnnounce(state, payload) {
    state.announcer = payload.message
    state.announcerLive = payload.live || 'polite'
  },

  pushToast(state, payload) {
    const id = state.toasts.length + 1
    state.toasts.push({
      id,
      text: payload
    })
  },

  popToast(state, id) {
    const idx = state.toasts.findIndex(i => i.id === id)
    state.toasts.splice(idx, 1)
  }
}

export const getters = {
  getTestById: state => testId => state.tests.find(test => test.id === testId),
  getFeature: state => featureName =>
    Boolean(state.features[featureName] && state.features[featureName] == '1'),
  getHostname: state => state.hostname
}
